import { render, staticRenderFns } from "./SidebarStyle.vue?vue&type=template&id=8a267ebc&scoped=true"
import script from "./SidebarStyle.vue?vue&type=script&lang=js"
export * from "./SidebarStyle.vue?vue&type=script&lang=js"
import style0 from "./SidebarStyle.vue?vue&type=style&index=0&id=8a267ebc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a267ebc",
  null
  
)

export default component.exports